import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/audioGuide/scan_icon.png';
const _hoisted_1 = {
  class: "container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_qrCode3 = _resolveComponent("qrCode3");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.isIos && !$data.showQrcode ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "scanText",
    onClick: _cache[0] || (_cache[0] = $event => $data.showQrcode = true)
  }, _cache[1] || (_cache[1] = [_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1), _createElementVNode("p", null, "点击开始扫码", -1)]))) : _createCommentVNode("", true), $data.showQrcode ? (_openBlock(), _createBlock(_component_qrCode3, {
    key: 1,
    show: $data.showQrcode
  }, null, 8, ["show"])) : _createCommentVNode("", true)]);
}